import React, { Component } from 'react';

class SidebarFooter extends Component {

  render() {
    return (
      <div className="sidebar-footer" style={{
        background: "rgba(0,0,0,0.1)",
        padding: "8px 12px",
        borderTop: "1px solid rgba(255,255,255,0.06)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "6px"
      }}>
        {[
          { href: "#/dashboard", icon: "fa-home", title: "Dashboard" },
          { href: "#/settings/expense", icon: "fa-cog", title: "Settings" },
          { href: "#/sales/acclist", icon: "fa-university", title: "Accounts" }
        ].map((item, i) => (
          <a key={i} href={item.href} title={item.title} style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "30px",
            height: "30px",
            borderRadius: "6px",
            background: "rgba(255,255,255,0.08)",
            color: "rgba(255,255,255,0.55)",
            fontSize: "13px",
            transition: "all 0.2s ease",
            textDecoration: "none"
          }}>
            <i className={"fa " + item.icon}></i>
          </a>
        ))}
      </div>
    )
  }
}

export default SidebarFooter;



// WEBPACK FOOTER //
// ./src/components/SidebarFooter/SidebarFooter.js